export const selectLoggedIn = ({ session }) => session.loggedIn;
export const selectShowKycBanner = ({ session }) => session.showKycBanner;
export const selectShowSessionReminder = ({ session }) => session.showSessionReminder;
export const selectShowRdlConfirmation = ({ session }) => session.showRdlConfirmation;
export const selectSessionStart = ({ session }) => session.sessionStart;
export const selectDefaultXrdlAmount = ({ session }) => session.defaultXrdlAmount;
export const selectShowXrdlPrompt = ({ session }) => session.showXrdlPrompt;
